module.exports = __webpack_public_path__ + "images/macbook-en-ebd44c.png";